export const isBgVideoView = () => document.body.classList.contains("has-bg-video");
